const REQUIRED_ASTERISK_SELECTOR = [
  "label",
  ".v-label",
  ".el-form-item__label",
  ".containerInfoHeight",
  ".overview-label",
  ".overview-field-label",
  ".group-form-member-label",
  ".create-tenant-description-label",
  ".container-edit-field-label"
].join(", ");

const REQUIRED_ASTERISK_CLASS = "required-asterisk";

const normalizeTrailingSpacing = (value: string) => value.replace(/\s+$/, "");

const processRequiredAsterisk = (element: Element) => {
  const host = element as HTMLElement;
  if (host.querySelector(`.${REQUIRED_ASTERISK_CLASS}`)) {
    return;
  }
  const text = host.textContent?.trim() ?? "";
  if (!text.endsWith("*")) {
    return;
  }

  const walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
  let targetNode: Text | null = null;
  let currentNode = walker.nextNode();
  while (currentNode) {
    if ((currentNode.textContent ?? "").includes("*")) {
      targetNode = currentNode as Text;
    }
    currentNode = walker.nextNode();
  }

  if (!targetNode) {
    return;
  }

  const originalText = targetNode.textContent ?? "";
  const starIndex = originalText.lastIndexOf("*");
  if (starIndex < 0) {
    return;
  }

  const before = normalizeTrailingSpacing(originalText.slice(0, starIndex));
  const after = originalText.slice(starIndex + 1);
  const fragment = document.createDocumentFragment();

  if (before) {
    fragment.appendChild(document.createTextNode(before));
  }

  const star = document.createElement("span");
  star.className = REQUIRED_ASTERISK_CLASS;
  star.textContent = "*";
  fragment.appendChild(star);

  if (after) {
    fragment.appendChild(document.createTextNode(after));
  }

  targetNode.parentNode?.replaceChild(fragment, targetNode);
};

const scanRequiredAsterisks = (root: ParentNode) => {
  root.querySelectorAll(REQUIRED_ASTERISK_SELECTOR).forEach(processRequiredAsterisk);
};

export const setupRequiredAsteriskStyling = () => {
  const runInitialScan = () => scanRequiredAsterisks(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitialScan, { once: true });
  } else {
    requestAnimationFrame(runInitialScan);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }
        if (node.matches(REQUIRED_ASTERISK_SELECTOR)) {
          processRequiredAsterisk(node);
        }
        scanRequiredAsterisks(node);
      });
    });
  });

  const startObserve = () => {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.body) {
    startObserve();
  } else {
    document.addEventListener("DOMContentLoaded", startObserve, { once: true });
  }

  return observer;
};
